import { useMemo } from "react";

import { useFormContext } from "@ui/components/Form";

import { useConfig } from "@jti/app-context/useConfig";
import { getPassVerifiedData, PASS_VERIFIED_PHONE_COOKIE } from "@jti/fe-common";

const KOREA_PHONE_COUNTRY_CODE = "82";
const KOREA_ISO_COUNTRY_CODE = "KR";

export type UsePhoneNumberFromAv = (fieldName: string) => {
  isAutopopulated: boolean;
};

export const usePhoneNumberFromAv: UsePhoneNumberFromAv = (fieldName) => {
  const { ISO_COUNTRY_CODE } = useConfig();
  const { setValue } = useFormContext();

  const isAutopopulated = useMemo(() => {
    const passVerifiedPhone = getPassVerifiedData(PASS_VERIFIED_PHONE_COOKIE);
    if (passVerifiedPhone && typeof passVerifiedPhone === "string") {
      // remove country code as The BE In the newest implementations added it manually to number fetched from PASS
      const isKoreanPrefixNotRequired =
        ISO_COUNTRY_CODE === KOREA_ISO_COUNTRY_CODE && passVerifiedPhone.startsWith(KOREA_PHONE_COUNTRY_CODE);

      const phoneNumberToPopulate = isKoreanPrefixNotRequired
        ? passVerifiedPhone.slice(KOREA_PHONE_COUNTRY_CODE.length)
        : passVerifiedPhone;

      setValue(fieldName, phoneNumberToPopulate);
    }
    return !!passVerifiedPhone;
  }, [fieldName, setValue]);

  return {
    isAutopopulated,
  };
};
